/**
 * Parse SRT subtitle file content
 * @param {string} srtContent - The content of the SRT file
 * @returns {Array} Array of subtitle objects with {id, startTime, endTime, text}
 */
export function parseSRT(srtContent) {
  const subtitles = [];
  const blocks = srtContent.trim().split(/\n\s*\n/);

  blocks.forEach((block) => {
    const lines = block.trim().split('\n');
    if (lines.length < 3) return;

    const id = parseInt(lines[0]);
    const timecode = lines[1];
    const text = lines.slice(2).join(' ').replace(/\r/g, '');

    const timeMatch = timecode.match(/(\d{2}):(\d{2}):(\d{2}),(\d{3})\s*-->\s*(\d{2}):(\d{2}):(\d{2}),(\d{3})/);
    if (timeMatch) {
      const startTime = 
        parseInt(timeMatch[1]) * 3600 +
        parseInt(timeMatch[2]) * 60 +
        parseInt(timeMatch[3]) +
        parseInt(timeMatch[4]) / 1000;
      
      const endTime = 
        parseInt(timeMatch[5]) * 3600 +
        parseInt(timeMatch[6]) * 60 +
        parseInt(timeMatch[7]) +
        parseInt(timeMatch[8]) / 1000;

      subtitles.push({
        id,
        startTime,
        endTime,
        text: text.trim()
      });
    }
  });

  return subtitles;
}

/**
 * Get current subtitle based on current time
 * @param {Array} subtitles - Array of subtitle objects
 * @param {number} currentTime - Current playback time in seconds
 * @returns {Object|null} Current subtitle object or null
 */
export function getCurrentSubtitle(subtitles, currentTime) {
  return subtitles.find(
    (subtitle) => currentTime >= subtitle.startTime && currentTime < subtitle.endTime
  ) || null;
}

